/**
 * Created by fajar on 01/24/2018.
 *
 * Declare available indonesian locale translation
 */

export default {
    'text': {
        'searching': 'Search',
        'search': 'Search',
        'search_query_param': 'Here is the search result of {key} {value}',
        'back_to_begining': 'Back to begining',
        'must_not_empty': 'Tidak boleh kosong',
        'min_length': '{field} minimal {count} karakter',
        'no_content': 'Data tidak ditemukan',
        'no_content_loaded': 'Tidak ada lagi konten dimuat',
        'loading': 'Memuat...',
        'reset_search': 'Tekan tombol dibawah untuk mereset hasil pencarian',
        'here_your_result': 'Berikut ini hasil dari pencarian anda',
        'download_santri_data_default': "Tekan download untuk mengunduh sampel excel data Santri",
        'upload_santri_data_default': "Upload data Santri dalam format excel",
        'download_tunggakan_data_default': "Tekan download untuk mengunduh sampel excel data Tunggakan",
        'download_tunggakan_data': "Tekan download untuk mengunduh data Tunggakan",
        'upload_tunggakan_data_default': "Upload data Tunggakan dalam format excel",
        'upload_perbaikan_data_default': "Upload perbaikan data santri format excel",
        'confirm_delete': 'Apakah anda yakin ingin menghapus data ini?',
        'some_input_not_valid': 'Terdapat inputan yang tidak valid!',
    },

    'placeholder': {
        'select_type_pay': "Jenis Bayar",
        'choose': "Pilih",
    },

    'button': {
        'close': 'Tutup',
        'add': 'Tambah',
        'print': 'Print',
        'add_data': 'Tambah',
        'copy_sesi': 'Copy sesi',
        'download': 'Download',
        'upload': 'Upload',
        'back': 'Kembali',
        'save': 'Simpan',
        'cancel': 'Batal',
        'reset_search': 'Reset Pencarian',
    },

    'jkel': {
        'L': 'Laki laki',
        'P': 'Perempuan'
    },

    'label': {
        'alert': 'Peringatan',
        'nama': 'Nama',
        'name': 'Nama',
        'kode': 'Kode',
        'code': 'Kode',
        'sku': 'SKU',
        'harga': 'Harga',
        'harga_beli': 'Harga Beli',
        'stock': 'Stok',
        'jenis_pay': 'Jenis Bayar',
        'pengambilan_kitab': 'Pengambilan Kitab',
        'kelengkapan_kitab': 'Kelengkapan Kitab',
        'nomor': 'Nomor',
        'komplek': 'Komplek',
        'choose': 'Pilih',
        'status_va': 'Virtual Account',
        'sekolah_asal': 'Sekolah Asal',
        'active': 'Aktif',
        'description': 'Keterangan',
        'keterangan': 'Keterangan',
        'searching': 'Pencarian',
        'search': 'Cari',
        'pemilik': 'Pemilik',
        'rekening': 'Rekening',
        'edit': 'Ubah',
        'saldo': 'Saldo',
        'nomor_rekening': 'No Rekening',
        'nama_rekening': 'Nama Rekening',
        'info': 'Info',
        'bank': 'Bank',
        'ukuran': 'Ukuran',
        'lulusan': 'Lulusan',
        'persyaratan': 'Persyaratan',
        'sekolah': 'Sekolah',
        'orang_tua': 'Orang Tua',
        'beranda': 'Beranda',
        'warning': 'Peringatan',
        'role': 'Jenis Akses',
        'session_empty': 'Sesi Anda telah habis',
        'login_again': 'Silahkan Login Kembali',
        'kode_asrama': 'Kode Asrama',
        'nama_asrama': 'Nama Asrama',
        'jenis_kelamin': 'Jenis Kelamin',
        'kelamin': 'Kelamin',
        'nama_pendaftar': 'Nama Pendaftar',
        'nama_santri': 'Nama Santri',
        'pencarian_santri': 'Pencarian Santri',
        'pimpinan': 'Pimpinan',
        'type': 'Jenis',
        'before_saldo': 'Saldo Sebelum',
        'after_saldo': 'Saldo Sesudah',
        'transaksi_type': 'Jenis Transaksi',
        'jenis_penarikan': 'Jenis Penarikan',
        'bulan': 'Bulan',
        'pondok': 'Pondok',
        'status': 'Status',
        'tahun': 'Tahun',
        'tahun_name': 'Tahun',
        'load_more': 'Muat Lagi',
        'pendidikan': 'Pendidikan',
        'wilayah': 'Wilayah Santri',
        'wil': 'Wilayah',
        'tagihan': 'Status Tagihan',
        'tanggal': 'Tanggal',
        'jumlah_transaksi': 'Transaksi',
        'jenis_transfer': 'Jenis Transfer',
        'jumlah_pembayar': 'Terbayar',
        'no_trx': 'Nomor Transaksi',
        'payment_method': 'Pembayaran',
        'kamar': 'Kamar',
        'pilih': 'Pilih',
        'created_by': 'User Kantin',
        'tgl_awal': 'Tanggal Awal',
        'tgl_akhir': 'Tanggal Akhir',
        'pengajian': 'Pengajian Santri',
        'peng': 'Pengajian',
        'nominal': 'Nominal',
        'total_nominal': 'Total Nominal',
        'jumlah_trx': 'Jumlah Transaksi',
        'jumlah': 'Jumlah',
        'jumlah_pendaftar': 'Jumlah Pendaftar',
        'virtual_account': 'Virtual Account',
        'pendidikan_formal': 'Formal',
        'pendidikan_non_formal': 'Non Formal',
        'pembayaran': 'Pembayaran',
        'terbayar_cash': 'Terbayar Cash',
        'terbayar_va': 'Terbayar VA',
        'nominal_cash': 'Nominal Cash',
        'nominal_va': 'Saldo VA',
        'belum_bayar': 'Belum Bayar',
        'formulir': 'Formulir',
        'proses': 'Proses',
        'bayar': 'Bayar',
        'kelas': 'Kelas',
        'tingkat': 'Tingkat',
        'asrama': 'Asrama Santri',
        'sekolah_santri': 'Sekolah Santri',
        'status_santri': 'Status Santri',
        'type_pay': 'Jenis Bayar',
        'nama_lengkap': 'Nama Lengkap',
        'nomor_pendaftar': 'Nomor',
        'tempat_tgl_lahir': 'Tempat Tgl Lahir',
        'penerima': 'Penerima',
        'status_tf': 'Status Transfer',
        'tuk_status': 'Status TUK',
        'username': 'Username',
        'profile': 'Profile',
        'email': 'Email',
        'bendahara_type': 'Tipe Bendahara',
        'phone': 'Phone',
        'not': 'Tidak',
        'yes': 'Ya',
        'trx_lunas': 'Lunas',
        'trx_belum': 'Belum',
        'date_trx': 'Tanggal Transaksi',
        'point_trx': 'Nilai Transaksi',
        'trx_tunggakan': 'Kekurangan',
        'nominal_bulan_1': 'Januari',
        'nominal_bulan_2': 'Februari',
        'nominal_bulan_3': 'Maret',
        'nominal_bulan_4': 'April',
        'nominal_bulan_5': 'Mei',
        'nominal_bulan_6': 'Juni',
        'nominal_bulan_7': 'Juli',
        'nominal_bulan_8': 'Agustus',
        'nominal_bulan_9': 'September',
        'nominal_bulan_10': 'Oktober',
        'nominal_bulan_11': 'November',
        'nominal_bulan_12': 'Desember',
        'jenis': 'Jenis',
        'waktu_sholat': 'Waktu Sholat',
        'waktu_mulai': 'Waktu Mulai',
        'waktu_selesai': 'Waktu Selesai',
        'is_active': 'Status',
        'nis': 'NIS',
        'sudah_absen': 'Status Absen',
        'tanggal_absen': 'Tanggal Absen',
        'presensi_status': 'Status Presensi',
        'presensi_tanggal': 'Tanggal Presensi',
        'deskripsi': 'Deskripsi',
        'product_name': 'Nama Produk',
        'movement_type': 'Tipe Pergerakan',
        'qty': 'Jumlah',
        'stock_before': 'Stok Sebelum',
        'stock_after': 'Stok Sesudah',
        'reference_type': 'Tipe Referensi',
        'note': 'Catatan',
        'total': 'Total',
        'paid_at': 'Tanggal Bayar',
        'created_at': 'Tanggal',
        'bank_soal_nama': 'Bank Soal',
        'bank_soal_id': 'ID Bank Soal',
        'total_detail': 'Total Soal',
        'total_benar': 'Total Benar',
        'total_salah': 'Total Salah',
        'kunci_jawaban': 'Kunci Jawaban',
        'category_name': 'Kategori',
        'title': 'Judul Program',
        'target_amount': 'Target',
        'current_amount': 'Terkumpul',
        'progress': 'Progress',
        'status_label': 'Status Program',
        'donor_count': 'Donatur',
        'start_date': 'Tgl Mulai',
        'end_date': 'Tgl Berakhir',
        'bank_name': 'Nama Bank',
        'bank_account_number': 'Nomor Rekening',
        'bank_account_name': 'Nama Pemilik Rekening',
        'category': 'Kategori',
        'pemasukan': 'Pemasukan',
        'pengeluaran': 'Pengeluaran',
        'tanggal_pemasukan': 'Tanggal Pemasukan',
        'tanggal_pengeluaran': 'Tanggal Pengeluaran',
        'jenis_pemasukan': 'Jenis Pemasukan',
        'jenis_pengeluaran': 'Jenis Pengeluaran',
        'jenis_pemasukan_id': 'Jenis Pemasukan',
        'jenis_pemasukan_nama': 'Jenis Pemasukan',
        'delete_data': 'Hapus',
        'aksi': 'Aksi',
        'wilayah_access': 'Akses Wilayah',
        'item_name': 'Item Pembayaran',
        'lokasi': 'Lokasi Kantin',
        'status_pembayaran': 'Pembayaran',
        'status_formulir': 'Formulir',
        'status_persyaratan': 'Persyaratan',
        'status_seragam': 'Seragam',
        'validasi': 'Validasi',
    },

    'notification': {
        '200': 'Operasi berhasil',
        '0000': 'Jaringan Bermasalah',
        '0010': 'Data berhasil disimpan',
        '0011': 'Data sudah ada!',
        '0012': 'Update gagal!',
        '0013': 'Update berhasil',
        '0014': 'Data berhasil dihapus',
        '0015': 'Data gagal dihapus!',
        '0016': 'Upload gagal!',
        '0017': 'Upload berhasil',
        '0018': 'Gagal menyambung koneksi',
        '0019': 'System exception',
        '0020': 'DB exception',
        '0021': 'Data tidak ditemukan',
        '0022': 'Data exceed limit',
        '0023': 'Operasi yang anda lakukan tidak diperbolehkan',
        '0024': 'Data tidak valid',
        '0025': 'Perintah tidak diijinkan',

        '1112': 'Operasi berhasil',
        '1101': 'Login Sukses',
        '1111': 'Input aplikasi tidak valid',
        '1102': 'Login Gagal!',
        '1103': 'Pengguna atau Kata sandi tidak terdaftar!',
        '1104': 'Sesi Anda telah kadaluarsa!',

        '1301': 'Kode Akses Pengerjaan soal berhasil di verifikasi',
        '1302': 'Kode Akses tidak valid',
    }
}
